import { productIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { BillOfMaterials } from "./bill-of-materials-types";

export const getBillOfMaterialsByOutputProducts = {
  name: "getBillOfMaterialsByOutputProducts" as const,
  input: z.object({ productIds: z.array(productIdFormat.schema) }),
  output: z.object({ billOfMaterials: z.array(BillOfMaterials) }),
};
